require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-evolvo-et-emergo.json") })
        }
      }, "path---projecten-evolvo-et-emergo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-evolvo-et-emergo!./.cache/json/projecten-evolvo-et-emergo.json
// module id = 414
// module chunks = 231608221292675